import script from "./recycleBin.vue?vue&type=script&lang=ts&setup=true"
export * from "./recycleBin.vue?vue&type=script&lang=ts&setup=true"

import "./recycleBin.vue?vue&type=style&index=0&id=3c6addc0&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c6addc0"]])

export default __exports__